// 22 Sep 2026 · Service-Worker-Registrierung + Cache-Löschung.
const SW_URL = "/sw.js";

export function registerSW() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(SW_URL).catch(() => { /* SW optional */ });
  });
}

// Löscht die Service-Worker-Caches (App-Shell). Wird bei Logout / abgelaufener
// Sitzung / Admin-Zwangs-Logout zusammen mit dem IndexedDB-Spiegel gerufen.
export function clearSWCaches() {
  try {
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: "WB_CLEAR_CACHES" });
    }
  } catch { /* ignore */ }
  try {
    if (typeof caches !== "undefined") {
      caches.keys().then((keys) =>
        keys.filter((k) => k.startsWith("wb-")).forEach((k) => caches.delete(k)),
      ).catch(() => {});
    }
  } catch { /* ignore */ }
}
